import { BaseAction } from '../../store/actions';
import {
  LoadJobsParams,
} from '../../shared/models/jobs';
import { Session } from '../../shared/models/session';

export enum SessionActions {

  StartSessionsPoll = '[Session] Start Sessions Poll',
  StopSessionsPoll = '[Session] Stop Sessions Poll',

  LoadSessions = '[Session] Load Sessions',
  LoadSessionsSuccess = '[Session] Load Sessions Success',
  LoadSessionsError = '[Session] Load Sessions Error',
}


export class StartSessionsPoll implements BaseAction<SessionActions>{
  readonly type = SessionActions.StartSessionsPoll;

  constructor(public readonly orgID: number, public readonly params: LoadJobsParams) {}
}

export class StopSessionsPoll implements BaseAction<SessionActions>{
  readonly type = SessionActions.StopSessionsPoll;
}


export class LoadSessions implements BaseAction<SessionActions> {
  readonly type = SessionActions.LoadSessions;

  constructor(public readonly orgID: number, public readonly params: LoadJobsParams) {}
}

export class LoadSessionsSuccess implements BaseAction<SessionActions> {
  readonly type = SessionActions.LoadSessionsSuccess;

  constructor(public readonly payload: Session[]) {}
}

export class LoadSessionsError implements BaseAction<SessionActions> {
  readonly type = SessionActions.LoadSessionsError;

  constructor(public readonly payload: string) {}
}

export type SessionAction = 
  LoadSessions | LoadSessionsSuccess | LoadSessionsError |
  StartSessionsPoll | StopSessionsPoll;
